import {
  ROOM_DOCUMENTS_ROUTE_NAME,
  ROOM_MEMBERS_ROUTE_NAME,
  ROOM_ROUTE_TYPES,
  SIGNING_CHECKLIST_ROUTE_NAME,
} from '@/router/routerData'

function getRoomColorTheme (room) {
  return room?.isDataroom
    ? 'deep-purple'
    : 'light-blue'
}

function getRoomCount (room, countName) {
  const NO_COUNTER_VALUE = '-'
  const { countsForRoom, countsForUser } = room

  if (countsForRoom?.[countName] >= 0) {
    return countsForRoom[countName]
  }

  if (countsForUser?.[countName] >= 0) {
    return countsForUser[countName]
  }

  return NO_COUNTER_VALUE
}

// The product icons of the two room types, as Material symbols rather than the images they used
// to be. The colours are the design system's own -500 shades, not the `icon-pink` / `icon-blue`
// aliases, which point at the darker -700 ones.
const ROOM_ICONS = {
  dataroom: { name: 'folder_check', color: 'pink-500' },
  project: { name: 'folder_shared', color: 'blue-500' },
}

/**
 * The Material icon standing for a room's type.
 * @param {Object} room The room to read the type from
 * @returns {{ name: string, color: string }} An icon name and colour for app-material-icon
 */
function getRoomIcon (room) {
  return room?.isDataroom
    ? ROOM_ICONS.dataroom
    : ROOM_ICONS.project
}

/**
 * Get roomType route param
 * @param {Object} room The room object to build route path for
 * @returns {typeof ROOM_ROUTE_TYPES[keyof typeof ROOM_ROUTE_TYPES]} A string to use as roomType param in the room route path
 */
function getRoomRouteType (room) {
  return room?.isDataroom
    ? ROOM_ROUTE_TYPES.DATAROOM
    : ROOM_ROUTE_TYPES.PROJECT
}

function getRoomDefaultRoute (room) {
  let defaultRouteName = ROOM_MEMBERS_ROUTE_NAME

  if (room.isDataroom) {
    defaultRouteName = ROOM_DOCUMENTS_ROUTE_NAME
  } else if (room.hasDocumentToSign) {
    defaultRouteName = SIGNING_CHECKLIST_ROUTE_NAME
  }

  return {
    name: defaultRouteName,
    params: {
      roomType: getRoomRouteType(room),
      mnemo: room.mnemo,
    },
  }
}

export {
  getRoomColorTheme,
  getRoomCount,
  getRoomIcon,
  getRoomRouteType,
  getRoomDefaultRoute,
  ROOM_ICONS,
}
